var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJavascript(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Unofficial_JavaScript_logo_2 1",
    clipPath: "url(#clip0_143_264)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M100.5 0H0.5V100H100.5V0Z",
    fill: "#F7DF1E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M67.6745 78.1254C69.6888 81.4143 72.3094 83.8318 76.9444 83.8318C80.838 83.8318 83.3253 81.8857 83.3253 79.1969C83.3253 75.9746 80.7698 74.8334 76.4841 72.9588L74.1348 71.9508C67.3539 69.0619 62.8491 65.4429 62.8491 57.7921C62.8491 50.7445 68.219 45.3794 76.611 45.3794C82.5856 45.3794 86.8809 47.4588 89.9761 52.9032L82.6586 57.6016C81.0475 54.7127 79.3094 53.5746 76.611 53.5746C73.8587 53.5746 72.1142 55.3207 72.1142 57.6016C72.1142 60.4207 73.8602 61.5619 77.892 63.308L80.2412 64.3143C88.2253 67.7381 92.7333 71.2286 92.7333 79.0762C92.7333 87.5365 86.0872 92.1715 77.1618 92.1715C68.4348 92.1715 62.7967 88.0127 60.038 82.5619L67.6745 78.1254ZM34.4793 78.9397C35.9555 81.5588 37.2983 83.773 40.5269 83.773C43.6142 83.773 45.5618 82.5651 45.5618 77.8683V45.9159H54.9586V77.9953C54.9586 87.7254 49.2539 92.154 40.9269 92.154C33.4031 92.154 29.046 88.2603 26.8301 83.5707L34.4793 78.9397Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_143_264"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJavascript);
export default __webpack_public_path__ + "static/media/javascript.7d2d5a0b9945e32eade6ddb4afcf3778.svg";
export { ForwardRef as ReactComponent };